import { SchedulerWoService } from '@feature/types/schedulerservice.type';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { WoserviceCreateType } from '@feature/types/woserviceCreate.type';
import { ENV } from "@app/constants/env";
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { getToken } from '@app/helpers/authProvider';
import { WoserviceCreateType } from '@feature/types/wo.service.create.type';

const API_BASE_URL = ENV.BASE_API_URL +ENV.JOB_APIURL;

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;

  if (typeof args === 'string') {
    args = { url: args };
  }

  try {
    const token = await getToken();
    if (token) {
      const headers =
        (args as FetchArgs).headers instanceof Headers
          ? (args as FetchArgs).headers
          : new Headers((args as FetchArgs).headers);

      headers.set('Authorization', `Bearer ${token}`);
      (args as FetchArgs).headers = headers;
    }

    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401 && token) {
      // refresh token flow could go here
    }

    return result;
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};
export const serviceSliceApi = createApi({
  reducerPath: 'serviceSliceApi',
  baseQuery: authBaseQuery,
  tagTypes: ['serviceSliceApi'],
  endpoints: (builder) => {
    const formatDate = (d: unknown) => (d instanceof Date ? d.toISOString() : d);

    const buildPayload = (service: WoserviceCreateType) => ({
      servicetype_Id: service.servicetype_id,
      status: service.status,
      workorder_Id: service.workorder_id,
      mstr_Show_Id: service.mstr_show_id,
      assignedto: service.assignedto,
      transport_Reference_Wos: service.transport_reference_wos,
      description: service.description,
      weight_N: service.weight_n,
      cbm_N: service.cbm_n,
      qty_N: service.qty_n,
      emptystorage: service.emptystorage,
      esvolume_N: service.esvolume_n,
      esquantity_N: service.esquantity_n,
      prioritystorage: service.prioritystorage,
      psvolume_N: service.psvolume_n,
      psquantity_N: service.psquantity_n,
      accessiblestorage: service.accessiblestorage,
      asvolume_N: service.asvolume_n,
      asquantity_N: service.asquantity_n,
      fullgoodsstorage: service.fullgoodsstorage,
      fgsvolume_N: service.fgsvolume_n,
      fgsquantity_N: service.fgsquantity_n,
      otherstorage: service.otherstorage,
      osvolume_N: service.osvolume_n,
      osquantity_N: service.osquantity_n,
      requireddate: formatDate(service.requireddate),
      timefrom: formatDate(service.timefrom),
      timeto: formatDate(service.timeto),
      totalminutes: service.totalminutes,
      charge: service.charge,
      comments: service.comments,
      warehouselocation: service.warehouselocation,
      staginglocation: service.staginglocation,
      portofdestination: service.portofdestination,
      portofdeparture: service.portofdeparture,
      agentorhomegameoffice: service.agentorhomegameoffice,
      containernumber: service.containernumber,
      eta: service.eta,
      etd: service.etd,
      transportmethod: service.transportmethod,
      flightvesselvehiclenumber: service.flightvesselvehiclenumber,
      mawb: service.mawb,
      hawb: service.hawb,
      destinationiatacode: service.destinationiatacode,
      departureiatacode: service.departureiatacode,
      destinationunlocodecode: service.destinationunlocodecode,
      departureunlocodecode: service.departureunlocodecode,
      pickupcityname: service.pickupcityname,
      pickupcountrycode: service.pickupcountrycode,
      pickupzipcode: service.pickupzipcode,
      deliverycityname: service.deliverycityname,
      deliveryzipcode: service.deliveryzipcode,
      deliverycountrycode: service.deliverycountrycode,
      truckwaybillnumber: service.truckwaybillnumber,
      destinationrailwaycode: service.destinationrailwaycode,
      departurerailwaycode: service.departurerailwaycode,
      railfreightwaybillnumber: service.railfreightwaybillnumber,
    });

    return {
      getServiceSchedulerData: builder.query<SchedulerWoService[], number>({
        query: (id) => `GetSchedulerWoserviceData/${id}`,
        providesTags: ['serviceSliceApi'],
      }),
      getLinkedTrafficServiceData: builder.query<SchedulerWoService[], number>({
        query: (id) => `GetLinkedTrafficServiceData/${id}`,
        providesTags: ['serviceSliceApi'],
      }),
    // postAddMultipleWoServiceData: builder.mutation<unknown, WoserviceCreateType>({
    //   query: (services) => ({
    //     url: 'api/WorkOrderService/CreateMultipleService',
    //   method: 'POST',
    //   body: buildPayload(services), // Assuming all services have the same structure
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   }),
    //   invalidatesTags: ['serviceSliceApi'],
    // }),
    postAddMultipleWoServiceData: builder.mutation<number[], WoserviceCreateType>({
      query: (body) => ({
        url: "api/WorkOrderService/CreateMultipleService",
        method: "POST",
        body,
      }),
    }),
    };
  },
});

export const {
  useGetServiceSchedulerDataQuery,
  useGetLinkedTrafficServiceDataQuery,
  usePostAddMultipleWoServiceDataMutation,
  //useSendMDGSearchDataMutation,
} = serviceSliceApi;
